module.exports = __webpack_public_path__ + "static/media/NB_AwardSeal_2021.b74c54ae.svg";